import { call, put, takeLatest } from "redux-saga/effects";
import {
  orglistLoad,
  orglistSuccess,
  orglistFailure,
  createOrgLoad,
  createOrgSuccess,
  createOrgFailure,
  addOrgModalHandler,
  orgUserListLoad,
  orgUserListFail,
  orgUserListSuccess,
  editOrgLoad,
  orgUserExportListLoad,
  editOrgUserLoad,
  editOrgUserSuccess,
  editOrgUserFail,
} from "../slices/org.slice";
import {
  createOrgApi,
  editOrgApi,
  editOrgUserApi,
  orgUserListApi,
  orglistApi,
  userListApi,
} from "../Api/api";
import { toast } from "react-toastify";
import { setModal } from "../../utils/global-func";

function* orgCreate(action) {
  try {
    const response = yield call(createOrgApi, action.payload);
    if (response?.status == 0) {
      toast.success(response?.result?.message);
      yield put(createOrgSuccess());
    } else {
      toast.error(response?.result?.message);
      yield put(createOrgFailure());
    }
  } catch (error) {
    toast.error("Some thing went wrong");
    yield put(createOrgFailure());
  }
}

function* editorgSaga(action) {
  try {
    const response = yield call(editOrgApi, action.payload);
    if (response?.status == 0) {
      toast.success(response?.result?.message);
      yield put(createOrgSuccess());
    } else {
      toast.error(response?.result?.message);
      yield put(createOrgFailure());
    }
  } catch (error) {
    toast.error("Some thing went wrong");
    yield put(createOrgFailure());
  }
}

function* orglist(action) {
  try {
    const response = yield call(orglistApi, action.payload);

    if (response?.status == 0) {
      yield put(orglistSuccess(response?.result?.data));
    } else {
      yield put(orglistFailure());
    }
  } catch (error) {
    yield put(orglistFailure());
  }
}

function* orgUserListSaga(action) {
  try {
    const data = yield call(orgUserListApi, action.payload);
    if (data.status === 0) {
      yield put(
        orgUserListSuccess({
          data: data.result.data,
          pagination: data.result.pagination,
        })
      );
    } else {
      yield put(orgUserListFail());
    }
  } catch {
    yield put(orgUserListFail());
  }
}

function* orgUserExportListSaga(action) {
  try {
    const data = yield call(orgUserListApi, action.payload);
    if (data.status === 0) {
      const Data = data?.result?.data?.userList;
      const headers = ["userId", "User Name", "Department", "Email"];
      const rows = Data.map((item) => [
        item?._id,
        item?.userName || "N/A",
        item?.department?.name || "N/A",
        item?.email,
      ]);

      const csvData = [headers, ...rows].map((row) => row.join(",")).join("\n");

      const blob = new Blob([csvData], { type: "text/csv" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = "orgUserList.csv";
      link.click();
    } else {
      yield put(orgUserListFail());
    }
  } catch {
    yield put(orgUserListFail());
  }
}

function* editOrgUserSaga(action) {
  try {
    const response = yield call(editOrgUserApi, action.payload.user);
    if (response?.status == 0) {
      toast.success(response?.result?.message);
      setModal(false);
      yield put(editOrgUserSuccess());
      yield put(orgUserListLoad(action.payload.payload));
    } else {
      toast.error(response?.result?.message);
      yield put(editOrgUserFail());
    }
  } catch (error) {
    toast.error("Some thing went wrong");
    yield put(editOrgUserFail());
  }
}

function* orgSaga() {
  yield takeLatest(createOrgLoad.type, orgCreate);
  yield takeLatest(editOrgLoad.type, editorgSaga);
  yield takeLatest(orglistLoad.type, orglist);
  yield takeLatest(orgUserListLoad.type, orgUserListSaga);
  yield takeLatest(orgUserExportListLoad.type, orgUserExportListSaga);
  yield takeLatest(editOrgUserLoad.type, editOrgUserSaga);
}

export default orgSaga;
